export enum WebContentFormatEnum {
  Image = 'Image',
  Document = 'Document',
  Export = 'Export',
  Html = 'HTML',
  Report = 'Report',
  Rss = 'RSS',
}
